import React from 'react';
import { NavLink, Link } from "react-router-dom";
import logoSrc from '../assets/logo.svg';
import logotipoSrc from '../assets/logotipo.svg';

const Header = (props) => {
   return(
      <header className="header">
         <div className="container">
            <div className="row align-bottom">
               <div className="col-md-2">
                  <Link to="/" className="logo">
                     <img className="logo__logo" src={logoSrc} alt=""/>
                     <img className="logo__logotipo" src={logotipoSrc} alt=""/>
                  </Link>
               </div>
               <div className="header__menu-container col-md-10">
                  <nav className="menu-links">
                     <ul className="menu-links__list">
                        <li className="menu-links__item menu-links__item--cta">                                
                           <NavLink className="menu-links__link" to="/sobre">Sobre</NavLink>
                        </li>
                        <li className="menu-links__item menu-links__item--cta">                                
                           <NavLink className="menu-links__link" to="/informacoes-importantes">Informações Importantes</NavLink>
                        </li>
                        <li className="menu-links__item menu-links__item--cta">                                
                           <NavLink className="menu-links__link" to="/se-sente-vulneravel">Se sente vulnerável?</NavLink>
                        </li>
                        <li className="menu-links__item menu-links__item--cta">                                
                           <NavLink className="menu-links__link" to="/meus-direitos">Meus direitos</NavLink>
                        </li>
                        <li className="menu-links__item menu-links__item--cta">                                
                           <NavLink className="menu-links__link" to="/equipe">Equipe</NavLink>
                        </li>
                        <li className="menu-links__item menu-links__item--cta">                                
                           <NavLink className="menu-links__link" to="/contato">Contato</NavLink>
                        </li>
                     </ul>
                  </nav>
               </div>
            </div>
         </div>
      </header>
   )
}

export default Header;